module.exports = __webpack_public_path__ + "assets/312608a4750a3e9da41afcad6859297c.png";